import clsx from 'clsx';
import './CatalogTagsMoreBadge.css';

export interface CatalogTagsMoreBadgeProps {
  hiddenCount: number;
  className?: string;
}

export function catalogTagsMoreLabel(hiddenCount: number): string {
  return `и ещё ${hiddenCount}…`;
}

export function CatalogTagsMoreBadge({ hiddenCount, className }: CatalogTagsMoreBadgeProps) {
  const label = catalogTagsMoreLabel(hiddenCount);
  return (
    <span
      className={clsx('catalog-tags-more-badge', className)}
      title={label}
    >
      {label}
    </span>
  );
}
